module.exports = __webpack_public_path__ + "img/snow.81132d8e.svg";